import React from 'react';
import styled from 'styled-components';
import { NavLink as RouterLink } from 'react-router-dom';
import { breakpoints } from '@sorted/sorted-ui';
import colors from '../colors';

const MenuLink = styled(({ to, ...props }) => {
	return (
		<RouterLink
			{...props}
			to={{ pathname: to, state: { fromHost: true } }}
		/>
	);
})`
	width: 100%;
	display: flex;
	box-sizing: border-box;
	align-items: center;
	text-decoration: none;
	height: 60px;
	white-space: nowrap;
	transition: background-color 0.1s ease, color 0.1s ease;
	padding-left: 53px;
	color: ${colors.white};

	@media (min-width: ${breakpoints.tablet}) {
		height: 90px;
		padding-left: 30px;
		padding-right: 16px;

		.settings & {
			height: 45px;
		}
	}

	&:hover {
		background-color: ${colors.black};
	}

	&.active {
		background-color: ${colors.pink};
		color: ${colors.white};
	}
`;

export default MenuLink;
